import actions from "./actions";

const initState = {
  restaurants: [],
  organizations: [],
  selectedRestaurant: "",
};

export default function getOrganizationAndRestaurantReducer(
  state = initState,
  action
) {
  switch (action.type) {
    case actions.SET_SELECTED_RESTAURANT:
      return {
        ...state,
        selectedRestaurant: action.restaurant,
      };

    case actions.GET_RESTAURANTS_SUCCESS:
      return {
        ...state,
        restaurants: action.restaurants,
      };
    case actions.GET_USER_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        organizations: action.organizations,
      };
    default:
      return state;
  }
}
